// extracted by mini-css-extract-plugin
module.exports = {"root":"TwoBarBurgerIcon_root__Lnj4A","bar":"TwoBarBurgerIcon_bar__rBxBq"};